import './component.scss'
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['review', 'reviewsOpen', 'reviewsClose']
  static values = { limit: { type: Number, default: 5 } }

  get className () {
    return this.element.dataset.classname
  }

  reviewsOpen () {
    this.reviewTargets.forEach((review, index) => {
      if (index >= this.limitValue) {
        review.classList.remove(`${this.className}::hidden`)
      }
    })
    this.reviewsOpenTarget.style.display = 'none'
    this.reviewsCloseTarget.style.display = 'flex'
  }

  reviewsClose () {
    this.reviewTargets.forEach((review, index) => {
      if (index >= this.limitValue) {
        review.classList.add(`${this.className}::hidden`)
      }
    })
    this.reviewsOpenTarget.style.display = 'flex'
    this.reviewsCloseTarget.style.display = 'none'
  }
}
